// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EzmA","toggle":"styles_toggle__kzxp1","preview":"styles_preview__25yRH"};